import { Theme } from '@mui/material';

export const styles = (theme: Theme) => {
  return {
    container: {
      height: 'inherit',
      width: '100%',
      display: 'flex',
      flex: '1',
      backgroundColor: 'background.default',
    },
    mainPage: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: 'background.paper',
      marginTop: theme.custom.margin.mediumXX,
      borderTopLeftRadius: theme.custom.borderRadius['2_75'],
      overflow: 'auto',
      alignItems: 'center',
      width: 'calc(100% - 232px)',
      '@media (max-width: 600px)': {
        marginTop: 0,
        borderTopLeftRadius: 0,
      },
    },
    removeMargin: {
      marginTop: 0,
      borderTopLeftRadius: 0,
      backgroundColor: 'background.default',
    },
    mainContainer: {
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      width: '160ch',
      '@media (max-width: 1920px)': {
        width: '100%',
      },
    },
    topRow: {
      flex: 1,
    },
    bottomRow: {
      display: 'flex',
      marginBottom: theme.custom.margin['3'],
      paddingLeft: theme.custom.margin.mediumXX,
      marginTop: theme.custom.margin.medium,
    },
    haleBottomRow: {
      alignItems: 'flex-end',
      justifyContent: 'space-between',
      gap: theme.custom.gap.medium,
      width: '100%',
      paddingRight: theme.custom.margin.mediumXX,
      '@media (max-width: 600px)': {
        flexDirection: 'column',
        alignItems: 'flex-end',
      },
    },
    haleQuoteWrapper: {
      flex: 1,
      minWidth: 0,
    },
  };
};
